import LocalizedStrings from 'localized-strings';

import { PaymentCardStatus } from '__generated__/GQL';

export default new LocalizedStrings({
  en: {
    clearFilters: 'Clear filters',
    filters: {
      cardProductType: {
        items: {
          budget: 'Budget',
          physical: 'Physical',
          temporary: 'Temporary',
          virtual: 'Virtual',
        },
        name: 'Card type',
      },
      owner: {
        name: 'Owner',
      },
      status: {
        items: {
          [PaymentCardStatus.Created]: 'Creation in progress',
          [PaymentCardStatus.Inactive]: 'To activate',
          [PaymentCardStatus.Active]: 'Active',
          [PaymentCardStatus.Lost]: 'Lost',
          [PaymentCardStatus.Locked]: 'Locked',
          [PaymentCardStatus.Deactivated]: 'Deactivated',
          [PaymentCardStatus.Stolen]: 'Stolen',
        },
        name: 'Status',
      },
    },
  },
  fr: {
    clearFilters: 'Effacer les filtres',
    filters: {
      cardProductType: {
        items: {
          budget: 'À Budget',
          physical: 'Physique',
          temporary: 'Éphémère',
          virtual: 'Virtuelle',
        },
        name: 'Type de carte',
      },
      owner: {
        name: 'Titulaire',
      },
      status: {
        items: {
          [PaymentCardStatus.Created]: 'En cours de création',
          [PaymentCardStatus.Inactive]: 'À activer',
          [PaymentCardStatus.Active]: 'Active',
          [PaymentCardStatus.Lost]: 'Perdue',
          [PaymentCardStatus.Locked]: 'Bloquée',
          [PaymentCardStatus.Deactivated]: 'Désactivée',
          [PaymentCardStatus.Stolen]: 'Volée',
        },
        name: 'Statuts',
      },
    },
  },
} as const);
